var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-logo"},[(_vm.isIndex)?[_c('img',{staticClass:"z-logo__img",attrs:{"src":_vm.buildSrc}})]:[_c('a',{staticClass:"z-logo__link",attrs:{"href":_vm.siteDir,"title":_vm.title}},[_c('img',{staticClass:"z-logo__img",attrs:{"src":_vm.buildSrc}})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }